import { defineMessages } from 'react-intl';

export const LoadBeeCardMessages = defineMessages({
  labelText: {
    defaultMessage: 'Weitere Herstellerinformationen von {brand}',
    id: 'loadbee.label.text',
  },
  modalHeadline: {
    defaultMessage: 'Herstellerinformationen {brand}',
    id: 'loadbee.modal.headline',
  },
});
